import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models/card-table-options.model';
import { CardTableAction } from 'libs/portal/src/modules/tools/card-table/models';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { UserAccessRole, UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { CardTableComponent } from 'libs/portal/src/modules/tools/card-table/components';
import { Routes } from '@huge-monorepo/portal/config';
import { GenericTableHeaderOptions, RefreshData } from 'libs/portal/src/modules/tools/card-table/models/generic-table-header-options.model';

export interface Alert {
  name: string;
  data: string;
  status: string;
  content: string;
  date: string;
  color: string;
  selected: boolean;
  Settings?: any;
  acceptedBy?: string;
  timeAccepted?: string;
  id?: number;
  kaid?: number;
  deviceid?: number;
  accepted?: boolean;
}

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
})
export class AlertsComponent implements OnInit, AfterViewInit {
  @ViewChild('sticky') sticky: TemplateRef<any>;
  @ViewChild('alertTable', { static: false }) public alertTable: CardTableComponent;

  loading = true;
  GroupID: number;
  orderBy = 'Timestamp';
  tableCount = 10;
  search = '';
  tableOffset = 0;
  currentPage = 1;
  desc = true;
  firstLoad = true;
  totalAlerts = 0;

  ScreenSize = ScreenSize;

  data: Alert[] = [];

  headerOptions: GenericTableHeaderOptions = {
    ShowSearch: true,
    SearchPlaceholder: 'Search Alerts',
    DefaultSort: 'Timestamp',
    DefaultDesc: true,
    SortItems: [
      {
        Name: 'Timestamp',
        Display: 'Date',
      },
      {
        Name: 'AcceptedBy',
        Display: 'Acknowledged By',
      },
      {
        Name: 'TimeAccepted',
        Display: 'Acknowledged On',
      },
    ],
  };

  options: CardTableOptions = {
    titleProperty: 'name',
    textSize: 'regular',
    rowId: 'id',
    subTitleProperty: 'data',
    additionalProperty: 'status',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['color', 'selected', 'status', 'id', 'deviceid', 'kaid', 'accepted'],
    stylePropertyPrefix: 'alerts',
    clickableFlexCard: false,
  };

  headers: CardTableHeader[] = [
    {
      ID: 'date',
      Text: 'Date',
      Width: 15,
    },
    {
      ID: 'name',
      Text: 'Device',
      Width: 10,
    },
    {
      ID: 'data',
      Text: 'Usage',
      Width: 20,
    },
    {
      ID: 'content',
      Text: 'Description',
      Width: 15,
    },
    {
      ID: 'acceptedBy',
      Text: 'Acknowledged By',
      Width: 18,
    },
    {
      ID: 'timeAccepted',
      Text: 'Acknowledged On',
      Width: 18,
    },
  ];

  listActions = [
    {
      title: 'View Device',
      iconSrc: 'assets/icon/devices.svg',
      color: 'primary',
      showIcon: true,
    },
  ];

  AccessObject: UserAccessRole;

  acceptedrowActions: CardTableAction[] = [];

  rowActions: CardTableAction[] = [];
  constructor(
    private titleService: TitleService,
    private navigationService: NavigationService,
    private layoutService: LayoutService,
    private endpoints: Endpoints,
    private genericService: GenericService,
    private tools: ToolsService,
    private auth: UserRightsService,
    private routeDictionary: Routes,
  ) {}

  ngAfterViewInit(): void {
    this.titleService.pageTitle = 'Alerts';
    this.layoutService.addStickyHeaderForRoute(this.navigationService.GetCurrentRoute(), this.sticky);
  }

  onAction($event: any) {
    if ($event.title == 'Acknowledge') {
      console.log('acknowledging', $event.row.id);
      this.genericService.GET(this.endpoints.ACCEPT_USAGE_ALERT($event.row.id)).subscribe((results) => {
        console.log('acknowledged', results);
        this.GetAlerts(this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc, true);
      });
    } else if ($event.title == 'View Device') {
      this.navigationService.Navigate(this.routeDictionary.CDRDeviceDetails, {
        state: {
          data: {
            CdrID: $event.row.deviceid,
            KaID: $event.row.kaid,
          },
        },
      });
    }
  }

  ngOnInit() {
    this.AccessObject = this.auth.GetUserAccessRoles();
    if (this.AccessObject == null) {
      return;
    }
    this.GroupID = this.auth.GetGroupID();

    if (this.AccessObject.HasCDRAccess() && this.AccessObject.IsCDRAdmin() && this.auth.GetUserPortalReadWrite().PortalWriteAccess) {
      const ackObj = {
        title: 'Acknowledge',
        iconSrc: 'assets/icon/check-square-regular.svg',
        color: 'primary',
        showIcon: true,
        display: true,
      };
      this.rowActions.push(ackObj);
      this.acceptedrowActions.push(ackObj);
    }
    this.GetAlerts(this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc, false);
  }

  GetAlerts(orderBy: string, search: string, count: number, offset: number, desc: boolean, opn: boolean) {
    this.loading = true;
    this.data = [];
    this.genericService
      .POST(this.endpoints.GET_ALERTS(count, offset, search, orderBy, desc, this.GroupID, opn), {
        GroupID: this.GroupID,
      })
      .subscribe((response) => {
        if (response['body'] != null) {
          response['body'].forEach((elem) => {
            if (elem.CDRDevice != null) {
              this.data.push({
                date: this.tools.FormatDateTimeFromDate(this.tools.ParseAPIDateWithTimezone(elem.Timestamp)),
                name: elem.CDRDevice.DeviceNum,
                data: `${this.tools.FormatUsage(elem.Data.Usage)} / ${this.tools.FormatUsage(elem.Data.InBundleAmount)} Used`,
                status: '',
                content: this.generateDescription(elem),
                color: elem.Accepted ? '#3FC944' : '#C96D01',
                selected: false,
                id: elem.ID,
                accepted: elem.Accepted,
                acceptedBy: elem.AcceptedBy != null ? elem.AcceptedBy : '-',
                timeAccepted: elem.TimeAccepted != null ? this.tools.FormatDateTimeFromDate(this.tools.ParseAPIDateWithTimezone(elem.TimeAccepted)) : '-',
                deviceid: elem.CDRDevice.ID,
                kaid: elem.KADeviceID,
              });
            }
          });
        }
        this.totalAlerts = this.tools.ExtractPaginationFromHeaders(response['headers']);
        this.loading = false;
        this.firstLoad = false;
      });
  }

  generateDescription(elem: Alert): string {
    if (elem.Settings.TypeID == 1) {
      return 'Exceeded bundle';
    } else if (elem.Settings.TypeID == 2) {
      return '80% over bundle';
    }
    return '';
  }

  refreshTable(data: RefreshData): void {
    this.search = data.Search ?? '';
    this.orderBy = data.Sort ?? '';
    this.desc = data.Desc ?? this.desc;
    this.tableOffset = 0;
    this.currentPage = 1;
    this.GetAlerts(this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc, false);
  }

  getPagedAlerts(pageIndex: number) {
    this.tableOffset = (pageIndex - 1) * this.tableCount;
    this.currentPage = pageIndex;
    this.GetAlerts(this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc, false);
  }
}
